module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "system-name"
  }, [_vm._v("喜马城市服务商智能管理系统")]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "unique-opened": true,
      "mode": "vertical",
      "default-active": _vm.$route.path
    }
  }, _vm._l((_vm.permission_routers), function(item) {
    return (!item.hidden && !(item.path == '/data/center' && !_vm.isPromotorDisplay)) ? _c('router-link', {
      key: item.text,
      attrs: {
        "to": item.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.text
      }
    }, [_c('div', {
      class: ("icon-img " + (item.icon))
    }), _vm._v(_vm._s(item.text))])], 1) : _vm._e()
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829f2f92","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 949
// module chunks = 1